import * as Types from "actions/types";
import axios from "axios";
import {endpoints} from "variables/variables.jsx";

export function postPaymentToken(user, data) {

  return (dispatch, failure) => {
    dispatch(postToken());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "post",
      url: endpoints.public+"/payment/token",
      headers: { Authorization: `Bearer ${token}` },
      data
    }).then( res =>{     
      dispatch(postTokenSuccess(user, res));
      return user;
    })
    .catch(() => dispatch(postTokenFailure()));
  };
}

function postToken() {
  return {
    type: Types.PAYMENT_TOKEN_POST
  };
}
function postTokenSuccess(user, data) {   
  return {
    type: Types.PAYMENT_TOKEN_POST_SUCCESS,
  };
}

function postTokenFailure(res) {
  return {
    type: Types.PAYMENT_TOKEN_POST_FAILURE
  }
}


export function getPaymentSourcesPromise(user, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "get",
    url: endpoints.public+"/payment/cards",
    headers: { Authorization: `Bearer ${token}` }
  })
  .then(res => {

      var data = res.data.data;

      dispatch(getSourcesSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getSourcesFailure(res)));  
}

export function getPaymentSources(user) {

  return (dispatch, failure) => {
    dispatch(getSources());
    return getPaymentSourcesPromise(user, dispatch);
  };
}

function getSources() {
  return {
    type: Types.PAYMENT_SOURCES_GET
  };
}

function getSourcesSuccess(shipments) {   
  return {
    type: Types.PAYMENT_SOURCES_GET_SUCCESS,
    shipments
  };
}

function getSourcesFailure() {
  return {
    type: Types.PAYMENT_SOURCES_GET_FAILURE
  }
}


export function deletePaymentSource(user, data) {

  return (dispatch, failure) => {
    dispatch(deleteSource());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "post",
      url: endpoints.public+"/payment/deletecard",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {     
        dispatch(deleteSourceSuccess(user, data));
        return user;
      })
      .catch(() => dispatch(deleteSourceFailure()));
  };
}


function deleteSource() {
  return {
    type: Types.PAYMENT_SOURCE_DELETE
  };
}

function deleteSourceSuccess(user, data) {   

  return {
    type: Types.PAYMENT_SOURCE_DELETE_SUCCESS,
  };
}

function deleteSourceFailure() {
  return {
    type: Types.PAYMENT_SOURCE_DELETE_FAILURE
  }
}

export function getShipmentPricePromise(user, data, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "post",
    url: endpoints.public+"/payment/shipment-price",
    headers: { Authorization: `Bearer ${token}` },
    data
  })
  .then(res => {

      var data = res.data.data;

      dispatch(getPriceSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getPriceFailure(res)));  
}

export function getShipmentPrice(user, data) {

  return (dispatch, failure) => {
    dispatch(getPrice());
    return getShipmentPricePromise(user, data, dispatch);
  };
}

function getPrice() {
  return {
    type: Types.PAYMENT_PRICE_GET
  };
}

function getPriceSuccess() {   
  return {
    type: Types.PAYMENT_PRICE_GET_SUCCESS,
  };
}

function getPriceFailure() {
  return {
    type: Types.PAYMENT_PRICE_GET_FAILURE
  }
}


export function getAllPaymentsPromise(user, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "get",
    url: endpoints.public+"/payment/all",
    headers: { Authorization: `Bearer ${token}` },
  })
  .then(res => {

      var data = res.data.data;

      dispatch(getPaymentsSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getPaymentsFailure(res)));  
}

export function getAllPayments(user, data) {

  return (dispatch, failure) => {
    dispatch(getPayments());
    return getAllPaymentsPromise(user, dispatch);
  };
}

function getPayments() {
  return {
    type: Types.PAYMENTS_GET
  };
}

function getPaymentsSuccess(payments) {   
  return {
    type: Types.PAYMENTS_GET_SUCCESS,
    payments
  };
}

function getPaymentsFailure() {
  return {
    type: Types.PAYMENTS_GET_FAILURE
  }
}


export function getStripeConnectLink(user){
  let token = user.signInUserSession.idToken.jwtToken;

  return (dispatch, failure) => {
    
    dispatch({
      type: Types.PAYMENTS_GET_STRIPE_LINK
    });
    
    return axios({
      method: "get",
      url: endpoints.public+"/payment/stripe-connect-link",
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(res => {

        var data = res.data.data;

        dispatch({
          type: Types.PAYMENTS_GET_STRIPE_CONNECT_LINK_SUCCESS,
          link: data.link
        });
        return data;
      })
    .catch((res) => dispatch({
        type: Types.PAYMENTS_GET_STRIPE_LINK_FAILURE
      }));  
  }
}


export function getStripeLoginLink(user){
  let token = user.signInUserSession.idToken.jwtToken;

  return (dispatch, failure) => {
    
    dispatch({
      type: Types.PAYMENTS_GET_STRIPE_LINK
    });
    
    return axios({
      method: "get",
      url: endpoints.public+"/payment/stripe-login-link",
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(res => {

        var data = res.data.data;

        dispatch({
          type: Types.PAYMENTS_GET_STRIPE_LOGIN_LINK_SUCCESS,
          link: data.url
        });
        return data;
      })
    .catch((res) => dispatch({
        type: Types.PAYMENTS_GET_STRIPE_LINK_FAILURE
      }));  
  }
}

export function getTransfers(user){
  let token = user.signInUserSession.idToken.jwtToken;

  return (dispatch, failure) => {
    
    dispatch({
      type: Types.PAYMENTS_GET_TRANSFERS
    });
    
    return axios({
      method: "get",
      url: endpoints.public+"/payment/transfers",
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(res => {

        var data = res.data.data;

        dispatch({
          type: Types.PAYMENTS_GET_TRANSFERS_SUCCESS,
          transfers: data
        });
        return data;
      })
    .catch((res) => dispatch({
        type: Types.PAYMENTS_GET_TRANSFERS_FAILURE
      }));  
  }
}

export function getAdminTransfers(user){
  let token = user.signInUserSession.idToken.jwtToken;

  return (dispatch, failure) => {
    
    dispatch({
      type: Types.PAYMENTS_GET_TRANSFERS
    });
    
    return axios({
      method: "get",
      url: endpoints.admin+"/payment/transfers",
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(res => {

        var data = res.data.data;

        dispatch({
          type: Types.PAYMENTS_GET_TRANSFERS_SUCCESS,
          transfers: data
        });
        return data;
      })
    .catch((res) => dispatch({
        type: Types.PAYMENTS_GET_TRANSFERS_FAILURE
      }));  
  }
}

export function postAdminTransfer(user, data){
  let token = user.signInUserSession.idToken.jwtToken;

  return (dispatch, failure) => {
    
    dispatch({
      type: Types.PAYMENTS_POST_TRANSFER
    });
    
    return axios({
      method: "post",
      url: endpoints.admin+"/payment/transfers",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {
        dispatch({
          type: Types.PAYMENTS_POST_TRANSFER_SUCCESS,
        });
        return user;
      })
    .catch((res) => dispatch({
        type: Types.PAYMENTS_POST_TRANSFER_FAILURE
      }));  
  }
}


// WEBPACK FOOTER //
// ./src/actions/payment.js